import ModalDrawer from "../../../../../common/components/organisme/ModalDrawer/ModalDrawer";
import useQueryURL from "../../../../../common/hooks/useQueryURL";


export const SINGLE_PAYGO_MODAL_ID = "single-paygo-modal";

export default function SinglePayGoModal({modalId, children}: {modalId?: string, children?: React.ReactNode}) {
  const modalIdFound = modalId || SINGLE_PAYGO_MODAL_ID;
  const { removeQueryValue } = useQueryURL();
  const onClose = () => {
    removeQueryValue(["paygoId", modalIdFound]);
  };



  return (
    <>
      <ModalDrawer
        urlParamName={modalIdFound}
        title= {"PayGo"}
        onClose={onClose}
      >
        {children}
      </ModalDrawer>
    </>
  );
}
